var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.493 2.494a.833.833 0 0 0-1.178 0L10.017 8.79l-6.28-6.28a.833.833 0 0 0-1.179 1.178l6.281 6.28-6.296 6.297a.833.833 0 1 0 1.179 1.178l6.295-6.296 6.311 6.311a.833.833 0 0 0 1.179-1.178l-6.311-6.311 6.296-6.296a.833.833 0 0 0 0-1.179Z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;